// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Play: React.FC<{ width?: number; height?: number }> = ({ width = 90, height = 90 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 90 90">
            <g fill="none">
                <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    stroke="#FFF"
                    stroke-linejoin="square"
                    stroke-width="2"
                    d="M89 45c0 24.3-19.7 44-44 44S1 69.3 1 45C1 22.374 18.158 3.496 40.5 1.227L45.05 1C69.3 1 89 20.699 89 45Z"
                />
                <path
                    fill="#00214A"
                    d="M37.971 30.343a2.478 2.478 0 0 0-2.625.067C34.471 30.88 34 31.75 34 32.686v24.628c0 .937.538 1.807 1.346 2.276a2.478 2.478 0 0 0 2.625.067l22.616-12.315A2.624 2.624 0 0 0 62 45a2.624 2.624 0 0 0-1.413-2.342L37.97 30.343Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Play);
